import { render } from "./Loader.vue?vue&type=template&id=d05371e4"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=d05371e4&lang=scss"
script.render = render

export default script